import { action, computed, observable, makeObservable } from 'mobx';

import { CallProviderType } from '@gem/call/Model/callModel.types';
import { MAX_COUNT_PARTICIPANTS } from '@gem/call/constants';

import { MainCall } from 'STORE/Calls/MainCall/MainCall';

import Entities from '../index';

export class Calls {
  root: typeof Entities;
  @observable hasWaitingRoomRequest = false;
  @observable activeCall: MainCall | null = null;
  @observable maxParticipants = MAX_COUNT_PARTICIPANTS;
  @observable callsProvider: CallProviderType = CallProviderType.Livekit;

  constructor(root: typeof Entities) {
    makeObservable(this);
    this.root = root;
  }

  @action async reset(): Promise<void> {
    if (this.activeCall) {
      await this.activeCall.delete();
    }
    this.activeCall = null;
    this.callsProvider = CallProviderType.Livekit;
  }

  @action
  setMaxParticipants(value = MAX_COUNT_PARTICIPANTS): void {
    this.maxParticipants = value;
  }

  @action
  add(call: MainCall): void {
    this.activeCall = call;
  }

  @action
  setCallsProvider(provider: CallProviderType): void {
    this.callsProvider = provider;
  }

  @action
  async delete(groupId: string | null, channelId: string | null): Promise<void> {
    if (
      this.activeCall &&
      (this.activeCall.channelId === channelId || this.activeCall.groupId === groupId)
    ) {
      await this.activeCall.delete();
      this.activeCall = null;
    }
  }

  getCallByGroupId(groupId: string): MainCall | null {
    return !!this.activeCall && !!groupId && this.activeCall.groupId === groupId
      ? this.activeCall
      : null;
  }

  getCallByChannelId(channelId: string): MainCall | null {
    return !!this.activeCall && channelId && this.activeCall.channelId === channelId
      ? this.activeCall
      : null;
  }

  @action
  setHasWaitingRoomRequest(hasWaitingRoomRequest: boolean): void {
    this.hasWaitingRoomRequest = hasWaitingRoomRequest;
  }

  @computed
  get ongoingCall(): MainCall | null {
    return this.activeCall;
  }
}
